export default [

  // Models --
  {
    id: "vinyl",
    type: "model",
    url: "/models/vinyl/scene.gltf",
  },
  {
    id: "cd",
    type: "model",
    url: "/models/cd/scene.gltf",
  },
  
  // library --
  {
    id: "foreground",
    type: "texture",
    url: "/assets/foreground.png",
    mipmaps:true
  },
  {
    id: "sideLeft",
    type: "texture",
    url: "/assets/left-side.png",
    mipmaps:true
  },
  {
    id: "sideRight",
    type: "texture",
    url: "/assets/right-side.png",
    mipmaps:true
  },
  {
    id: "background",
    type: "texture",
    url: "/assets/background.png",
    mipmaps:true
  },
  {
    id: "box",
    type: "texture",
    url: "/assets/box.png",
    mipmaps:true
  },
  {
    id: "box_glow",
    type: "texture",
    url: "/assets/box_glow.png",
    mipmaps:true
  },
  {
    id: "record",
    type: "texture",
    url: "/assets/record_player.png",
    mipmaps:true
  },
  {
    id: "record_glow",
    type: "texture",
    url: "/assets/record_player_glow.png",
    mipmaps:true
  },
  {
    id: "partitions",
    type: "texture",
    url: "/assets/partitions.png",
    mipmaps:true
  },
  {
    id: "partitions_glow",
    type: "texture",
    url: "/assets/partitions_glow.png",
    mipmaps:true
  },
  {
    id: "typewriter",
    type: "texture",
    url: "/assets/typewriter.png",
    mipmaps:true
  },
  {
    id: "typewriter_glow",
    type: "texture",
    url: "/assets/typewriter_glow.png",
    mipmaps:true
  },
  {
    id: "poster",
    url: "/assets/poster.png",
    type: "texture",
    mipmaps:true
  },
  {
    id: "poster_glow",
    type: "texture",
    url: "/assets/poster_glow.png",
    mipmaps:true
  },
  {
    id: "carnet",
    url: "/assets/carnet.png",
    type: "texture",
    mipmaps:true
  },
  {
    id: "carnet_glow",
    type: "texture",
    url: "/assets/carnet_glow.png",
    mipmaps:true
  },
  {
    id: "livre",
    url: "/assets/livre-charles.png",
    type: "texture",
    mipmaps:true
  },
  {
    id: "livre_glow",
    type: "texture",
    url: "/assets/livre-charles_glow.png",
    mipmaps:true
  },
  {
    id: "violon",
    type: "texture",
    url: "/assets/violon.png",
    mipmaps:true
  },
  {
    id: "violon_glow",
    type: "texture",
    url: "/assets/violon_glow.png",
    mipmaps:true
  },
  {
    id: "ligne-home",
    type: "svg",
    url: "/home/ligne.svg",
  },

  // Thematique --
  // YNS
  {
    id: "yns-svg",
    type: "svg",
    url: "/thematiques/yannick-nezet-seguin/lines.svg",
  },
  {
    id: "yns-spritesheet",
    type: "spritesheet",
    url: "/thematiques/yannick-nezet-seguin/animation/",
  },
  //Oeuvres preferees
  {
    id: "art-svg",
    type: "svg",
    url: "/thematiques/oeuvres-preferees/lines.svg",
  },
  {
    id: "art-spritesheet",
    type: "spritesheet",
    url: "/thematiques/oeuvres-preferees/animation/",
  },
  //Charles Dutoit
  {
    id: "charles-svg",
    type: "svg",
    url: "/thematiques/charles-dutoit/lines.svg",
  },
  {
    id: "charles-spritesheet",
    type: "spritesheet",
    url: "/thematiques/charles-dutoit/animation/",
  },
  //Festival de Lanaudiere
  {
    id: "festival-svg",
    type: "svg",
    url: "/thematiques/festival-de-lanaudiere/lines.svg",
  },
  {
    id: "festival-spritesheet",
    type: "spritesheet",
    url: "/thematiques/festival-de-lanaudiere/animation/",
  },
  //Metier de critique
  {
    id: "metier-svg",
    type: "svg",
    url: "/thematiques/metier-role-de-critique/lines.svg",
  },
  {
    id: "metier-spritesheet",
    type: "spritesheet",
    url: "/thematiques/metier-role-de-critique/animation/",
  },
  //UDM
  {
    id: "university-svg",
    type: "svg",
    url: "/thematiques/universite-de-montreal/lines.svg",
  },
  {
    id: "university-spritesheet",
    type: "spritesheet",
    url: "/thematiques/universite-de-montreal/animation/",
  },
  //Les raretes
  {
    id: "rarete-svg",
    type: "svg",
    url: "/thematiques/les-raretes/lines.svg",
  },
  {
    id: "rarete-spritesheet",
    type: "spritesheet",
    url: "/thematiques/les-raretes/animation/",
  },
  //Maria Callas
  {
    id: "maria-svg",
    type: "svg",
    url: "/thematiques/maria-callas/lines.svg",
  },
  {
    id: "maria-spritesheet",
    type: "spritesheet",
    url: "/thematiques/maria-callas/animation/",
  },

  // Sounds --
  {
    id: "home-track",
    type: "sound",
    url: "/home/track.mp3",
  },
  {
    id: "yns-track",
    type: "sound",
    url: "/thematiques/yannick-nezet-seguin/animation/yns-track.mp3",
  },
  {
    id: "charles-track",
    type: "sound",
    url: "/thematiques/charles-dutoit/animation/charles-track.mp3",
  },
  {
    id: "art-track",
    type: "sound",
    url: "/thematiques/oeuvres-preferees/animation/art-track.mp3",
  },
  {
    id: "festival-track",
    type: "sound",
    url: "/thematiques/festival-de-lanaudiere/animation/festival-track.mp3",
  },
  {
    id: "rarete-track",
    type: "sound",
    url: "/thematiques/les-raretes/animation/rarete-track.mp3",
  },
  {
    id: "metier-track",
    type: "sound",
    url: "/thematiques/metier-role-de-critique/animation/metier-track.mp3",
  },
  {
    id: "university-track",
    type: "sound",
    url: "/thematiques/universite-de-montreal/animation/university-track.mp3",
  },
  {
    id: "maria-track",
    type: "sound",
    url: "/thematiques/maria-callas/animation/maria-track.mp3",
  },

  // UI
  {
    id: "sprite-object",
    type: "texture",
    url: "/assets/interaction.png",
  },
  {
    id: "touch-object",
    type: "texture",
    url: "/assets/interaction-touch.png",
  },
];

